/* eslint-disable no-console */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-await-in-loop */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/button';
import styles from './forms.module.scss';
import PulpoField from '../../pulpo_visualizer/fields';
import FormSubmitted from '../forms/components/FormSubmitted';
import Collapsible from '../../components/collapsible/Collapsible';
import Loading from '../../components/loading';
import Attachments from '../forms/components/Attachments';
import Panel from '../../components/panel';
import { isLocal, hostName } from '../../constants/apiEnv';
import { GetFileName, S3Uploads } from '../services';

const url = hostName.slice(6);

class NoiseLogForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFormErrors: false,
      answers: {},
      apiStatus: undefined,
      message: undefined,
      publicFiledValidations: {},
      loadingStatus: false,
      attachmentFields: []
    };
    const { match: { params: { id } } } = props;
    localStorage.setItem('portalBackendId', id);
    this.publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${id}${url}/public`;
  }

  async componentDidMount() {
    const { match: { params: { airportCode } } } = this.props;
    try {
      this.setState({ loadingStatus: true });
      await fetch(`${this.publicUrl}/noise_log/get_schema/${airportCode}`)
        .then(response => response.json())
        .then((data) => {
          let requiredMap = {};
          let fieldErrors = {};
          let conditionalFields = {};
          const attachmentFields = [];
          const fields = data?.schema?.schema?.fields.filter(field => (
            field?.internal !== true
          ));
          fields.forEach((detailField) => {
            if (detailField.type !== 'dataSource'
                && detailField.type !== 'dataSourceMultiselect'
                && detailField.type !== 'page_break'
                && detailField.type !== 'header') {
              requiredMap = {
                ...requiredMap,
                [detailField.id]: detailField.required
              };
              if (!detailField.conditional) {
                fieldErrors = {
                  ...fieldErrors,
                  [detailField.id]: detailField.required
                };
              } else {
                conditionalFields[detailField?.conditional_field?.key] = detailField;
              }
            }
            if (detailField.type === 'attachments') attachmentFields.push(detailField.id);
          });
          localStorage.setItem('timeFormat', data?.airport_data?.time_format === '24' ? 'HH:mm' : 'hh:mm A');
          localStorage.setItem('dateFormat', data?.airport_data?.date_format || 'MM/DD/YYYY');
          this.setState({
            publicFiledValidations: data.public_attributes||{},
            noiseLog: data,
            fields,
            requiredMap,
            fieldErrors,
            loadingStatus: false,
            attachmentFields,
            conditionalFields
          });
        });
    } catch (error) {
      console.log(error);
      let message = 'There was a problem while retrieving the form';
      this.setState({
        message,
        apiStatus: true,
        loadingStatus: false
      });
    }
  }

  handleAnswerChanged = (answer, fieldId, type) => {
    const { conditionalFields, publicFiledValidations } = this.state;
    if (conditionalFields?.[fieldId] && conditionalFields?.[fieldId].required) {
      const conditionValues = conditionalFields[fieldId]?.conditional_values;
      let fieldValue = answer;
      let enabelCondition = false;
      if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
      if (typeof fieldValue === 'object' && fieldValue?.level_0) {
        enabelCondition = Object.values(fieldValue)?.filter(value => value !== '')?.join()
        === Object.values(conditionValues[0])?.filter(value => value !== '')?.join();
      } else {
      enabelCondition = conditionValues.some(value => fieldValue?.includes(value?.value));
      }
      this.handleFieldErrorChanged(conditionalFields[fieldId].id, enabelCondition);
      this.setState(prevState => ({
        answers: {
          ...prevState.answers,
          [fieldId]: answer,
          [conditionalFields[fieldId].id]: ''
        }
      }));
    } else {
      if (type === 'default' && Object.keys(publicFiledValidations).indexOf(fieldId) >= 0) {
        let errVal = false;
        if ((answer.trim()==='')) {
          errVal = true;
        }
      this.setState({
        publicFiledValidations: {
          ...publicFiledValidations,
          [fieldId]: errVal
        }
      });
    }
      this.setState(prevState => ({
        answers: {
          ...prevState.answers,
          [fieldId]: answer
        }
      }));
    }
  }

  handleFieldErrorChanged = (fieldId, errorValue) => {
    // Updates field error map with value passed from field component
    this.setState(prevState => ({
      ...prevState,
      fieldErrors: {
        ...prevState.fieldErrors,
        [fieldId]: errorValue
      }
    }));
  }

  checkConditionalValue = (field) => {
    const { answers } = this.state;

    let isValue = false;
    if (typeof answers[field?.conditional_field?.key] === 'string') {
      isValue = field?.conditional_values.filter(
        value => answers[field?.conditional_field?.key] === value.value
      ).length > 0;
    } else if (typeof answers[field?.conditional_field?.key] === 'object') {
      if (Array.isArray(answers[field?.conditional_field?.key])) {
        isValue = field?.conditional_values.some(
            value => answers[field?.conditional_field?.key]?.indexOf(value.value) !== -1
        );
    } else if (answers[field?.conditional_field?.key]?.level_0) {
      isValue = Object.values(answers[field?.conditional_field?.key])
        ?.filter(value => value !== '')
        ?.join() === Object.values(field.conditional_values[0])
        ?.filter(value => value !== '')
        ?.join();
    }
   } else if (typeof answers[field?.conditional_field?.key] === 'boolean') {
      isValue = field?.conditional_values.filter(
        value => (
          answers[field?.conditional_field?.key].toString() === value?.value
        )
      ).length > 0;
    }
    return isValue;
  }

  handleSubmit = async () => {
    const { fieldErrors, attachmentFields, publicFiledValidations,
      answers: { email, name, phone, last_name, ...form_data },
      fields = []
    } = this.state;
    const { match: { params: { airportCode } } } = this.props;
    if (publicFiledValidations.none) delete publicFiledValidations.none;
    let success_message = '';
    if (publicFiledValidations.hasOwnProperty('success_message')) {
      success_message = publicFiledValidations?.success_message;
      delete publicFiledValidations.success_message;
    }
    const noErrors = Object.keys(fieldErrors)
      .every(k => (fieldErrors[k] === false));
      const puberr = Object.keys(publicFiledValidations)
      .every(k => (publicFiledValidations[k] === false));
      if (noErrors&&puberr) {
      this.setState({ loadingStatus: true });
      let number = phone;
      if (number) number = number[0] + number.slice(1).replace(/[^\d]/g, '');
      if (attachmentFields.length > 0) {
        for (let index=0; index < attachmentFields.length; index++) {
          const attachmentField = attachmentFields[index];
          if (form_data[attachmentField]) {
            let fileIds = '';
            fileIds = await this.getFileNames(form_data[attachmentField]?.length, airportCode);
            if (fileIds) {
              await this.doS3Upload(
                form_data[attachmentField],
                fileIds,
                'noise_log'
              );
              form_data[attachmentField] = [];
              fileIds.filename.forEach((attachmentId) => {
                form_data[attachmentField].push(attachmentId.toString());
              });
            }
          }
        }
      }

      fields.forEach((val) => {
        const phoneType = val?.type === 'string' && val?.validators?.length > 0 && val?.validators[0]?.label === 'Phone Number' && val;
        if (phoneType && form_data[phoneType.id]) form_data[phoneType.id] = form_data[phoneType.id][0] + form_data[phoneType.id].slice(1).replace(/[^\d]/g, '');
      });

      const data = {
        incident_date: new Date(),
        email,
        name,
        last_name,
        phone: number,
        data: form_data
      };
      try {
        await fetch(`${this.publicUrl}/noise_log/create_noiselog/${airportCode}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' }
          })
          .then(response => response.json())
          .then(() => {
              this.setState({
                message: success_message || 'Your Noise Log entry has been submitted successfully.',
                apiStatus: true,
                loadingStatus: false
              });
          });
      } catch (error) {
        let message = 'There was a problem while submitting the form';
        if (error && error.detail) message = error.detail;
        this.setState({
          message,
          apiStatus: true,
          loadingStatus: false
        });
      }
    } else {
      this.setState({ showFormErrors: true });
    }
  }

  getFileNames = async (count, airportCode) => {
    const response = await GetFileName.getPublicUploadFileName(count, airportCode);
    return response;
  };

  doS3Upload = async (files, fileIds, entity) => {
    const { match } = this.props;
    const installation = match.params.id;
    const airportCode = match.params?.airportCode;
    const response = await S3Uploads.uploadFiles(
        files,
        fileIds.filename,
        entity,
        installation,
        airportCode
    );
    return response;
  };

  render() {
    const { answers, showFormErrors, noiseLog, requiredMap, message,
      apiStatus, loadingStatus, fields } = this.state;
    return (
    <>
      <Loading loadingStatus={loadingStatus} />
      {!apiStatus && noiseLog && Object.keys(noiseLog).length > 0 && (
      <>
        <div className={styles.title}>
          <img src={noiseLog?.airport_data?.image} alt="" />
        </div>
        <div className={styles.container}>
        <Panel containerClasses={styles.panel} title="noise.form.title" defaultTitle="Noise Report">
          <div className={styles.details}>
              <div className={styles.details_form}>
                {noiseLog?.public_attributes?.name && (
                  <PulpoField key="name" id="name" type="string" title="Name"
                    translationID="noise_log.complete.name"
                    handleValueChange={(a, b) => this.handleAnswerChanged(a, b, 'default')}
                    answer={answers.name} isRequired
                    showFieldErrors={showFormErrors}
                    handleFieldErrorChanged={this.handleFieldErrorChanged}
                  />
                  )}
                  {noiseLog?.public_attributes?.last_name && (
                  <PulpoField key="last_name" id="last_name" type="string" title="Last Name"
                    translationID="forms.complete.last_name"
                    handleValueChange={(a, b) => this.handleAnswerChanged(a, b, 'default')}
                    answer={answers.last_name} isRequired
                    showFieldErrors={showFormErrors}
                    handleFieldErrorChanged={this.handleFieldErrorChanged}
                  />
                  )}
                  {noiseLog?.public_attributes?.email && (
                  <PulpoField key="email" id="email" type="string" title="Email"
                    translationID="forms.complete.email"
                    handleValueChange={(a, b) => this.handleAnswerChanged(a, b, 'default')}
                    answer={answers.email} isRequired
                    showFieldErrors={showFormErrors}
                    handleFieldErrorChanged={this.handleFieldErrorChanged}
                  />
                  )}
                  {noiseLog?.public_attributes?.phone && (
                  <PulpoField key="phone" id="phone" type="telephone"
                    title="Phone" isRequired
                    translationID="forms.complete.phone"
                    handleValueChange={(a, b) => this.handleAnswerChanged(a, b, 'default')}
                    answer={answers.phone}
                    showFieldErrors={showFormErrors}
                    handleFieldErrorChanged={this.handleFieldErrorChanged}
                  />
                )}
              </div>
              <div className={styles.details_form}>
                {requiredMap && fields.map(field => (
                <>
                  {!field.conditional && (
                    <>
                      {field.type === 'header' && (
                          <>
                            {field.collapsible ? (
                              <div className={styles.collapseHeader}>
                              <Collapsible
                                  title={field.title} openOnMount
                                  styleClasses={styles.header}
                              >
                                  <div>
                                      <pre className={styles.description}>
                                          {field.description}
                                      </pre>
                                  </div>
                              </Collapsible>
                              </div>
                            ): (
                              <>
                                <div className={styles.header}>
                                    {field.title}
                                </div>
                                <div>
                                    <pre className={styles.description}>
                                        {field.description}
                                    </pre>
                                </div>
                              </>
                            )}
                          </>
                      )}
                    {field.type === 'map_location' && (
                      <PulpoField key={field.id} {...field} airportInfo={noiseLog.airport_data}
                        handleValueChange={this.handleAnswerChanged}
                        isRequired={requiredMap[field.id]} answer={answers[field.id]}
                        showFieldErrors={showFormErrors} handleFieldErrorChanged={this.handleFieldErrorChanged}
                        className={styles.fullWidth} addressEnabled={field?.address_location}
                        title={field?.address_location ? 'Address' : field.title}
                        translationID={field?.address_location ? 'custom_field.address.title' : field.title}
                        locationId={field.title}
                        locationTitle={field.title}
                      />
                    )}
                    {field.type === 'attachments' && (
                      <Attachments
                        {...field}
                        handleAnswerChanged={this.handleAnswerChanged}
                        attachments={answers[field.id]}
                        showFieldErrors={showFormErrors}
                        handleFieldErrorChanged={this.handleFieldErrorChanged}
                      />
                    )}
                    {field.type !== 'dataSource'
                      && field.type !== 'dataSourceMultiselect'
                      && field.type !== 'page_break'
                      && field.type !== 'header'
                      && field.type !== 'attachments'
                      && field.type !== 'map_location'
                      && field?.type !== 'multi_level'
                      && (
                      <PulpoField key={field.id} {...field} onlyTime={field.type === 'time'}
                        translation={field.title} handleValueChange={this.handleAnswerChanged}
                        isRequired={requiredMap[field.id]} answer={answers[field.id]}
                        showFieldErrors={showFormErrors} handleFieldErrorChanged={this.handleFieldErrorChanged}
                        className={(field.full_width || field.id === 'type_of_event') ? styles.fullWidth : ''} customField
                        noDefault={(field.type === 'time' || field.type.includes('date')) && !field?.default}
                        type={(field.type === 'string' && field?.validators?.length>0 && field?.validators[0]?.label === 'Phone Number')
                            ? 'telephone': field.type}
                      />
                    )}
                      { field?.type === 'multi_level'
                    && (
                    <>
                      {/* don't even change the props passing position here,
                           it will raise not displaying or page break issues */}
                      <PulpoField
                        {...field}
                        levels={{
                          level_0: {
                            title: `${field?.title}`
                          },
                          level_1: {
                            title: `${field?.title} 1`
                          },
                          level_2: {
                            title: `${field?.title} 2`
                          }
                        }}
                        title={field?.title}
                        values={typeof field.values === 'object'
                          ?Object.values(field.values).map(item => ({ ...item, name: item.title })):[]}
                        handleValueChange={this.handleAnswerChanged}
                        handleFieldErrorChanged={this.handleFieldErrorChanged}
                        isRequired={requiredMap[field.id]}
                        showFieldErrors={showFormErrors}
                        forFormModule
                        answer={answers && answers[field.id]}
                        type="dataSourceMultiLevel"
                      />
                    </>)
                  }
                    </>
                  )}
                  {field.conditional && answers[field?.conditional_field?.key] && this.checkConditionalValue(field) && (
                    <>
                      {field.type === 'header' && (
                          <>
                            {field.collapsible ? (
                              <div className={styles.collapseHeader}>
                              <Collapsible
                                  title={field.title} openOnMount
                                  styleClasses={styles.header}
                              >
                                  <div>
                                      <pre className={styles.description}>
                                          {field.description}
                                      </pre>
                                  </div>
                              </Collapsible>
                              </div>
                            ): (
                              <>
                                <div className={styles.header}>
                                    {field.title}
                                </div>
                                <div>
                                    <pre className={styles.description}>
                                        {field.description}
                                    </pre>
                                </div>
                              </>
                            )}
                          </>
                      )}
                    {field.type === 'map_location' && (
                      <PulpoField key={field.id} {...field} airportInfo={noiseLog.airport_data}
                        translation={field.title} handleValueChange={this.handleAnswerChanged}
                        isRequired={requiredMap[field.id]} answer={answers[field.id]}
                        showFieldErrors={showFormErrors} handleFieldErrorChanged={this.handleFieldErrorChanged}
                        className={styles.fullWidth}
                      />
                    )}
                    {field.type === 'attachments' && (
                      <Attachments
                        {...field}
                        handleAnswerChanged={this.handleAnswerChanged}
                        attachments={answers[field.id]}
                        showFieldErrors={showFormErrors}
                        handleFieldErrorChanged={this.handleFieldErrorChanged}
                      />
                    )}
                    {field.type !== 'dataSource'
                      && field.type !== 'dataSourceMultiselect'
                      && field.type !== 'page_break'
                      && field.type !== 'header'
                      && field.type !== 'attachments'
                      && field.type !== 'map_location'
                      && field.type !== 'multi_level'
                      && (
                      <PulpoField key={field.id} {...field} onlyTime={field.type === 'time'}
                        translation={field.title} handleValueChange={this.handleAnswerChanged}
                        isRequired={requiredMap[field.id]} answer={answers[field.id]}
                        showFieldErrors={showFormErrors} handleFieldErrorChanged={this.handleFieldErrorChanged}
                        className={(field.full_width || field.id === 'type_of_event') ? styles.fullWidth : ''} customField
                        noDefault={(field.type === 'time' || field.type.includes('date')) && !field?.default}
                        type={(field.type === 'string' && field?.validators?.length>0 && field?.validators[0]?.label === 'Phone Number')
                            ? 'telephone': field.type}
                      />
                    )}
                   { field?.type === 'multi_level'
                    && (
                    <>
                      {/* don't even change the props passing position here,
                           it will raise not displaying or page break issues */}
                      <PulpoField
                        {...field}
                        levels={{
                          level_0: {
                            title: `${field?.title}`
                          },
                          level_1: {
                            title: `${field?.title} 1`
                          },
                          level_2: {
                            title: `${field?.title} 2`
                          }
                        }}
                        title={field?.title}
                        values={typeof field.values === 'object'
                          ?Object.values(field.values).map(item => ({ ...item, name: item.title })):[]}
                        handleValueChange={this.handleAnswerChanged}
                        handleFieldErrorChanged={this.handleFieldErrorChanged}
                        isRequired={requiredMap[field.id]}
                        showFieldErrors={showFormErrors}
                        forFormModule
                        answer={answers && answers[field.id]}
                        type="dataSourceMultiLevel"
                      />
                    </>)
                  }
                    </>
                  )}
                </>
                ))}
              </div>
              <div className={styles.footer}>
                <Button action="secondary" onClick={this.handleSubmit}
                  translationID="form.submit_form" defaultText="Submit Form"
                />
                <span>
                  <a href="https://www.aerosimple.com" target="_blank" rel="noopener noreferrer">
                    Powered by Aerosimple
                  </a>
                </span>
              </div>
          </div>
        </Panel>
        </div>
      </>
      )}
      {apiStatus && (
        <div className="container">
          <FormSubmitted name={noiseLog && noiseLog.title}
            successMessage={message} logo={noiseLog?.airport_data?.image}
          />
        </div>
      )}
    </>
    );
  }
}

NoiseLogForm.propTypes = {
  history: PropTypes.shape({}).isRequired
};

export default NoiseLogForm;
